<script lang="ts">
  import '#lib/i18n.ts';
  import '../app.css';

  import '@tailwindplus/elements';

  import { browser } from '$app/env';
  import { page } from '$app/state';
  import * as Sentry from '@sentry/svelte';
  import { onMount } from 'svelte';
  import TrackingScripts from './TrackingScripts.svelte';

  onMount(async () => {
    if (browser) {
      const response = await fetch(`/api/config`);
      const config = await response.json();

      if (config.sentryDsn) {
        Sentry.init({
          dsn: config.sentryDsn,
          tracesSampleRate: 1.0
        });
      }
    }
  });

  let { children } = $props();
</script>

{#if import.meta.env.PROD && !page.url.hostname.includes('test')}
  <TrackingScripts />
{/if}

{@render children()}
